import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface DateChipOption {
  value: string;
  label: string;
  sublabel?: string;
}

@Component({
  selector: 'app-date-chip-row',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="date-chip-row" *ngIf="options.length" aria-label="Available dates">
      <button
        class="date-chip"
        type="button"
        *ngFor="let option of options"
        [class.active]="value === option.value"
        (click)="selected.emit(option.value)"
      >
        <span>{{ option.label }}</span>
        <small *ngIf="option.sublabel">{{ option.sublabel }}</small>
      </button>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        min-width: 0;
        max-width: 100%;
        overflow: hidden;
      }

      .date-chip-row {
        display: flex;
        gap: 7px;
        overflow-x: auto;
        max-width: 100%;
        padding: 1px 1px 4px;
        scrollbar-width: none;
      }

      .date-chip-row::-webkit-scrollbar {
        display: none;
      }

      .date-chip {
        flex: 0 0 auto;
        min-height: 36px;
        border: 1px solid var(--line);
        border-radius: 999px;
        padding: 5px 11px;
        color: var(--muted);
        background: var(--control-bg);
        display: grid;
        place-items: center;
        gap: 1px;
        font: inherit;
        font-size: 12px;
        font-weight: 900;
        cursor: pointer;
      }

      .date-chip small {
        color: var(--faint);
        font-size: 10px;
        font-weight: 850;
      }

      .date-chip.active {
        color: var(--accent-contrast);
        border-color: var(--cyan);
        background: var(--cyan);
        box-shadow: 0 8px 20px rgba(88, 224, 255, 0.16);
      }

      .date-chip.active small {
        color: var(--accent-contrast);
      }

      @media (max-width: 640px) {
        .date-chip {
          min-height: 34px;
          padding: 5px 10px;
          font-size: 12px;
        }
      }
    `,
  ],
})
export class DateChipRowComponent {
  @Input() options: DateChipOption[] = [];
  @Input() value = '';
  @Output() selected = new EventEmitter<string>();
}
